import { ACTIONS } from '../actions/rating'

export const initialState = {
    database: {
        ratings: [],
    },
    appState: {
        getRatingsError: null,
        getRatingsLoading: false,
        postRatingError: null,
        postRatingLoading: false,
    },
}

export default (state = initialState, action) => {
    const { appState, database } = state

    switch (action.type) {
        case ACTIONS.GET_RATINGS.START:
            return {
                ...state,
                database: { ...database, getRatingsLoading: true },
            }
        case ACTIONS.GET_RATINGS.SUCCESS:
            return {
                ...state,
                database: { ...database, getRatingsError: null, getRatingsLoading: false },
            }
        case ACTIONS.GET_RATINGS.FAILURE:
            return {
                ...state,
                database: { ...database, getRatingsError: action.error, getRatingsLoading: false },
            }

        case ACTIONS.POST_RATING.START:
            return {
                ...state,
                appState: { ...appState, postRatingLoading: true },
            }
        case ACTIONS.POST_RATING.SUCCESS:
            return {
                ...state,
                appState: { ...appState, postRatingError: null, postRatingLoading: false },
            }
        case ACTIONS.POST_RATING.FAILURE:
            return {
                ...state,
                appState: { ...appState, postRatingError: action.error, postRatingLoading: false },
            }

        default:
            return state
    }
}
